import { render, staticRenderFns } from "./CategoriesV2.vue?vue&type=template&id=03647781&scoped=true"
import script from "./CategoriesV2.vue?vue&type=script&lang=js"
export * from "./CategoriesV2.vue?vue&type=script&lang=js"
import style0 from "./CategoriesV2.vue?vue&type=style&index=0&id=03647781&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03647781",
  null
  
)

export default component.exports